import { render, staticRenderFns } from "./HubList.vue?vue&type=template&id=16864f78"
import script from "./HubList.vue?vue&type=script&lang=js"
export * from "./HubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports